import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { UserContext } from '../_models/user-context'

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
  intercept (req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const uctx = JSON.parse(sessionStorage.getItem('ArubaProvisioningWebFrontEnd:currentUser')) as UserContext;
    if (uctx && uctx.securityToken) {
      const authReq = req.clone({
        headers: req.headers.set('Authorization', `Basic ${uctx.securityToken}`)
      });
      return next.handle(authReq);
    }
    else
      return next.handle(req);
  }
}



// WEBPACK FOOTER //
// ./src/app/_interceptors/basicauth.interceptor.ts